import { render, staticRenderFns } from "./DesktopIcon.vue?vue&type=template&id=a6bda05e&"
import script from "./DesktopIcon.vue?vue&type=script&lang=js&"
export * from "./DesktopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports